import { MapRefs } from './types';
import { BELARUS_BOUNDS } from './constants';
import { updateUserLocationMarker, updateMarkerPosition } from './mapUtils';
import toast from 'react-hot-toast';

export const handleMyLocationClick = (
  refs: MapRefs,
  setUserLocation: (location: [number, number]) => void,
  onClick?: (lat: number, lng: number) => void
) => {
  if (!navigator.geolocation) {
    toast.error('Геалакацыя не падтрымліваецца вашым браўзерам');
    return;
  }

  toast.loading('Вызначэнне месцазнаходжання...', { id: 'geolocation' });

  navigator.geolocation.getCurrentPosition(
    (position) => {
      const coords: [number, number] = [position.coords.latitude, position.coords.longitude];
      
      if (coords[0] < BELARUS_BOUNDS[0][0] || coords[0] > BELARUS_BOUNDS[1][0] ||
          coords[1] < BELARUS_BOUNDS[0][1] || coords[1] > BELARUS_BOUNDS[1][1]) {
        toast.error('Ваша месцазнаходжанне за межамі Беларусі', { id: 'geolocation' });
        return;
      }

      setUserLocation(coords);
      
      if (refs.mapInstanceRef.current) {
        refs.mapInstanceRef.current.setCenter(coords, 14);
        updateUserLocationMarker(coords, refs);
        
        if (onClick) {
          onClick(coords[0], coords[1]);
          updateMarkerPosition(coords, refs, onClick);
        }
      }

      toast.success('Месцазнаходжанне вызначана', { id: 'geolocation' });
    },
    (error) => {
      console.error('Geolocation error:', error);
      let errorMessage = 'Не атрымалася вызначыць месцазнаходжанне';
      
      switch (error.code) {
        case error.PERMISSION_DENIED:
          errorMessage = 'Доступ да геалакацыі забаронены';
          break;
        case error.POSITION_UNAVAILABLE:
          errorMessage = 'Інфармацыя аб месцазнаходжанні недаступная';
          break;
        case error.TIMEOUT:
          errorMessage = 'Час чакання вызначэння месцазнаходжання скончыўся';
          break;
      }
      
      toast.error(errorMessage, { id: 'geolocation' });
    },
    {
      enableHighAccuracy: true,
      timeout: 10000,
      maximumAge: 300000
    }
  );
};